import { RouterProvider } from 'react-router-dom';
import { router } from '@/app/routes';
import { useSessionBootstrap } from '@mmef/shared/auth';

export function App() {
  useSessionBootstrap();
  return <RouterProvider router={router} />;
}
